import { project2BaseUrl } from './remoteClient'

export async function registrationRequest(createdUser, recaptchaToken) {
    const res = await project2BaseUrl.post(
        `/auth/registration?recaptchaToken=${encodeURIComponent(recaptchaToken)}`,
        createdUser
    );
    return res;
}


export async function loginRequest(username, password, recaptchaToken) {
    let credentials = {
        username,
        password
    }

    let res = await project2BaseUrl.post("/auth/login?recaptchaToken="+recaptchaToken, credentials)
    return res
}

export async function logoutRequest(id) {
    return await project2BaseUrl.post('/auth/logout', id);
}


export async function updatePasswordRequest(username, password, key) {
    let credentials = {
        username,
        password,
        key
    };
    const response = await project2BaseUrl.post('/auth/updatePassword', credentials);

    if (response.status === 200) {
        window.location.href = "https://demo.nationaltalenthub.com";
    } else {
        throw response.status
    }
    return response;
}

export async function forgotPasswordRequest(email, recaptchaToken) { 
    let payload = { 'email':email, 'token' : recaptchaToken };
    return await project2BaseUrl.post(`/auth/forgotPassword`, payload);
}
